<template>
  <!-- The Modal -->
  <div id="modal-cookieCookie" class="modal-cookie" v-if="show">

    <!-- Modal content -->
    <div class="modal-cookie-content">
      <div class="modal-cookie-header">
        <span class="modal-cookie-close" @click="controllerShowModal">&times;</span>
        <br>
      </div>
      <div class="modal-cookie-body">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-sm-12">
              <p>
                Nuestra plataforma utiliza cookies para mejorar la experiencia de nuestros usuarios. Cada vez que utilizas nuestro portal, autorizas el uso de cookies para almacenar información y generar estadísticas de audiencia analizando tu navegación. <br>
                <strong>Consulta nuestra Política de Cookies en la Red para más información.</strong>
              </p>
            </div>
            <div class="col-md-4 col-sm-12 mt-20px">
              <div class="row trusted-content">
                <div class="col-md-6 col-sm-6">
                  <div class="trusted__btn">
                    <button class="trusted__btn-btn btn btn-outline-dark btn-lg btn-block" @click="controllerApprovedCookies">Aceptar</button>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6">
                  <div class="trusted__btn">
                    <button class="trusted__btn-btn btn btn-outline-dark btn-lg btn-block" @click="controllerConsultarCookies">Consultar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-cookie-footer">
        <br>
      </div>
    </div>

  </div>
</template>

<script>
require('@/assets/css/modal-cookies.css');

export default {
  name: "CookieModal", 
  data() {
    return {
      show: true
    }
  },
  beforeMount() {
    this.checkApprovedCookies();
  },
  methods: {
    controllerShowModal() {
      this.show = !this.show;
    },
    controllerApprovedCookies () {
      this.setCookie('approvedCookies',true,365);
      this.controllerShowModal();
    },
    controllerConsultarCookies () {
      window.location.href = '/politica-de-cookies';
      this.controllerShowModal();
    },
    checkApprovedCookies() {
      let approvedCookie = this.getCookie('approvedCookies');
      if (approvedCookie!=='') {
        this.show = !(approvedCookie==='true');
      } else {
        this.show = true;
      }
    },
    setCookie(cname, cvalue, exdays=999) {
      let d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  },
}
</script>

<style scoped>
  
</style>